/**
 * Story 2.38: compara um CNPJ (que pode estar formatado no banco como
 * '57.571.275/0006-07') com um termo de busca (formatado ou nao).
 *
 * Normaliza AMBOS removendo caracteres nao-numericos antes de comparar
 * por substring. Funciona tanto com '57.571.275/0006-07' quanto com
 * '57571275000607' no input.
 *
 * Termo com menos de 3 digitos retorna false (evita matches absurdos
 * tipo "1" matchando metade da base).
 *
 * @example
 *   cnpjMatch('57.571.275/0006-07', '57571275000607')  // true
 *   cnpjMatch('57.571.275/0006-07', '57.571.275')      // true
 *   cnpjMatch('57.571.275/0006-07', '0006-07')         // true
 *   cnpjMatch('57.571.275/0006-07', '57')              // false (< 3 digitos)
 *   cnpjMatch(null, '12345')                            // false
 */
export function cnpjMatch(
  cnpjStored: string | null | undefined,
  query: string,
): boolean {
  if (!cnpjStored || !query) return false;
  const onlyDigits = (s: string) => s.replace(/\D/g, '');
  const queryDigits = onlyDigits(query);
  if (queryDigits.length < 3) return false;
  const storedDigits = onlyDigits(cnpjStored);
  return storedDigits.includes(queryDigits);
}
